function pandalinoNormalizeRut(value) {
  const cleaned = (value || '').replace(/\./g, '').replace(/-/g, '').toUpperCase().trim();
  if (cleaned.length < 2) return cleaned;

  const body = cleaned.slice(0, -1).replace(/\D/g, '');
  const verifier = cleaned.slice(-1);
  if (!body) return cleaned;

  return `${body}-${verifier}`;
}

function pandalinoIsValidRut(value) {
  const normalized = pandalinoNormalizeRut(value);
  const parts = normalized.split('-');
  if (parts.length !== 2) return false;

  const body = parts[0];
  const verifier = parts[1];
  if (!/^\d+$/.test(body) || !/^[0-9K]$/.test(verifier)) return false;

  let sum = 0;
  let multiplier = 2;
  for (let index = body.length - 1; index >= 0; index -= 1) {
    sum += parseInt(body[index], 10) * multiplier;
    multiplier = multiplier === 7 ? 2 : multiplier + 1;
  }

  const remainder = 11 - (sum % 11);
  let expected = '';
  if (remainder === 11) expected = '0';
  else if (remainder === 10) expected = 'K';
  else expected = `${remainder}`;

  return expected === verifier;
}

function pandalinoBillingAttributes(container) {
  const selectedDocument = container.querySelector('[data-billing-document]:checked')?.value || '';
  const baseAttributes = {
    billing_documento: selectedDocument,
    billing_rut: '',
    billing_rzn_social: '',
    billing_giro: '',
  };

  container.querySelectorAll('input[name^="attributes["]').forEach((input) => {
    const matches = input.name.match(/^attributes\[(.+)\]$/);
    if (!matches) return;
    const key = matches[1];

    if (input.type === 'radio') return;
    if (input.hidden || input.closest('[hidden]')) return;

    baseAttributes[key] = input.hasAttribute('data-rut-input')
      ? pandalinoNormalizeRut(input.value)
      : input.value;
  });

  return baseAttributes;
}

function pandalinoSyncBillingVisibility(container) {
  const selectedDocument = container.querySelector('[data-billing-document]:checked')?.value || '';
  const extraGroup = container.querySelector('[data-billing-extra]');
  if (extraGroup) {
    const isFactura = selectedDocument === '33';
    extraGroup.hidden = !isFactura;
    extraGroup.querySelectorAll('input').forEach((input) => {
      input.disabled = !isFactura;
      if (!isFactura) {
        input.removeAttribute('aria-invalid');
      }
    });
  }

  container.querySelectorAll('[data-field-error]').forEach((node) => {
    if (selectedDocument !== '33' && node.getAttribute('data-field-error') !== 'attributes[billing_rut]') {
      node.hidden = true;
      node.textContent = '';
    }
  });
}

function pandalinoSetFieldError(input, message) {
  const field = input.closest('.field');
  const errorNode = field?.querySelector(`[data-field-error="${input.name}"]`);

  input.toggleAttribute('aria-invalid', Boolean(message));
  if (!errorNode) return;

  errorNode.hidden = !message;
  errorNode.textContent = message || '';
}

function pandalinoValidateRequiredFields(container) {
  const selectedDocument = container.querySelector('[data-billing-document]:checked')?.value || '';
  let valid = true;

  container.querySelectorAll('.field input[name^="attributes["]').forEach((input) => {
    if (!(input instanceof HTMLInputElement) || input.disabled) return;
    if (selectedDocument !== '33' && input.name !== 'attributes[billing_rut]') return;

    if (!input.value.trim()) {
      pandalinoSetFieldError(input, input.dataset.requiredMessage || 'Completa este campo');
      valid = false;
      return;
    }

    pandalinoSetFieldError(input, '');
  });

  return valid;
}

function pandalinoUpdateRutState(container) {
  const activeRutInput = container.querySelector('[data-rut-input]');
  const errorNode = container.querySelector('[data-rut-error]');

  if (!activeRutInput || !activeRutInput.value.trim()) {
    if (errorNode) {
      errorNode.hidden = true;
      errorNode.textContent = '';
    }
    if (activeRutInput) activeRutInput.removeAttribute('aria-invalid');
    return true;
  }

  const normalized = pandalinoNormalizeRut(activeRutInput.value);
  activeRutInput.value = normalized;
  const valid = pandalinoIsValidRut(normalized);

  if (errorNode) {
    errorNode.hidden = true;
    errorNode.textContent = '';
  }
  if (valid) {
    pandalinoSetFieldError(activeRutInput, '');
  } else {
    pandalinoSetFieldError(activeRutInput, 'RUT invalido');
  }
  return valid;
}

function pandalinoPersistBilling(container) {
  const attributes = pandalinoBillingAttributes(container);
  fetch(`${routes.cart_update_url}`, {
    ...fetchConfig(),
    body: JSON.stringify({ attributes }),
  });
}

function pandalinoSetupCartPage() {
  const billingContainer = document.querySelector('[data-pandalino-billing]');
  if (!billingContainer || billingContainer.dataset.initialized === 'true') return;
  billingContainer.dataset.initialized = 'true';

  pandalinoSyncBillingVisibility(billingContainer);
  pandalinoUpdateRutState(billingContainer);

  billingContainer.addEventListener('change', (event) => {
    const target = event.target;
    if (!(target instanceof HTMLInputElement)) return;

    if (target.hasAttribute('data-rut-input')) {
      target.value = pandalinoNormalizeRut(target.value);
    }

    pandalinoSyncBillingVisibility(billingContainer);
    pandalinoValidateRequiredFields(billingContainer);
    pandalinoUpdateRutState(billingContainer);
    pandalinoPersistBilling(billingContainer);
  });

  billingContainer.addEventListener('blur', (event) => {
    const target = event.target;
    if (!(target instanceof HTMLInputElement)) return;

    if (target.hasAttribute('data-rut-input')) {
      target.value = pandalinoNormalizeRut(target.value);
      pandalinoUpdateRutState(billingContainer);
    } else if (target.disabled) {
      return;
    } else if (!target.value.trim()) {
      pandalinoSetFieldError(target, target.dataset.requiredMessage || 'Completa este campo');
    } else {
      pandalinoSetFieldError(target, '');
    }

    pandalinoPersistBilling(billingContainer);
  }, true);

  const cartForm = document.getElementById('cart');
  if (!cartForm) return;

  cartForm.addEventListener('submit', (event) => {
    const submitter = event.submitter;
    if (!(submitter instanceof HTMLElement) || submitter.getAttribute('name') !== 'checkout') return;
    const requiredFieldsValid = pandalinoValidateRequiredFields(billingContainer);
    const rutValid = pandalinoUpdateRutState(billingContainer);
    if (requiredFieldsValid && rutValid) return;

    event.preventDefault();
  });
}

document.addEventListener('DOMContentLoaded', pandalinoSetupCartPage);
document.addEventListener('cart:change', pandalinoSetupCartPage);
